<!-- 控销-商品管理 -->
<template>
  <div class="classification">
    <div class="header">
      <el-form ref="formTool"
               :model="formTool"
               :inline="true"
               style="text-align: left">
        <el-form-item label="">
          <el-input v-model.trim="formTool.shopName"
                    placeholder="请输入商户名称"
                    clearable
                    size="small" />
        </el-form-item>
        <el-form-item label="">
          <el-input v-model.trim="formTool.goodsCode"
                    placeholder="请输入商品编码"
                    clearable
                    size="small" />
        </el-form-item>
        
        <el-form-item label="">
          <el-input v-model.trim="formTool.goodsName"
                    placeholder="请输入商品名称"
                    clearable
                    size="small" />
        </el-form-item>
        <el-form-item label="">
          <el-input v-model.trim="formTool.factory"
                    placeholder="请输入生产厂家"
                    clearable
                    size="small" />
        </el-form-item>
        <el-form-item label="">
          <el-input v-model.trim="formTool.keyWords"
                    placeholder="请输入部门名称"
                    clearable
                    size="small" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formTool.status"
                     clearable
                     style="width: 120px;"
                     size="small"
                     placeholder="状态">
            <el-option v-for="item in options"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small"
                     type="primary"
                     @click="getList(1)">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small"
                     @click="reset()">重置</el-button>
        </el-form-item>

      </el-form>

    </div>

    <div class="center"
         style="position: relative">
      <MyTable :table-data="tableData"
               :index="index"
               :selection="selection"
               :page="page"
               :operation="operation"
               :table-option.sync="tableOption"
               @page-change="getList"
               @handleSelectionChange="handleSelectionChange">
        <template slot="price"
                  slot-scope="scope"
                  style="width: 140px;">
          <span v-if="scope.row.minPrice">
            {{scope.row.minPrice  }}
          </span>
          <span v-if="scope.row.maxPrice">
            ~ {{scope.row.maxPrice  }}
          </span>
        </template>

        <template slot="salesUserRate"
                  slot-scope="scope"
                  style="width: 140px;">
          <span v-if="scope.row.salesUserRate">
            {{scope.row.salesUserRateText }} %
          </span>
        </template>

        <template slot="status"
                  slot-scope="scope">
          <span style="color:#E6A23C"
                v-if="scope.row.status == 0"><i class="el-icon-success"></i> 待审核</span>
          <span style="color:#67C23A"
                v-if="scope.row.status == 1 "><i class="el-icon-warning"></i> 审核通过</span>
          <span style="color:#F5222d"
                v-if="scope.row.status == 2 "><i class="el-icon-warning"></i> 审核驳回</span>
        </template>

        <template slot="image"
                  slot-scope="scope">
          <el-row>
            <el-col style="width:80px">
              <el-image :src="scope.row.image
                ? scope.row.image
                : avater
                "
                        lazy
                        style="width: 80px; height: 80px" />
            </el-col>
            <el-col style="width:calc(100% - 90px);margin-left:10px">

              <el-row> {{ scope.row.name }} </el-row>
              <el-row>
                {{ scope.row.specification }}
              </el-row>
              <el-row>
                {{ scope.row.factory }}
              </el-row>
              <el-row>
                {{ scope.row.approvalNumber }}
              </el-row>
              <el-row>
                商品编码： {{ scope.row.goodsCode }}
              </el-row>

            </el-col>
          </el-row>
        </template>
        <!-- contactName -->

        <template slot="contactName"
                  slot-scope="scope"
                  style="width: 300px;">
          <span> {{ scope.row.contactName }}</span>
          <span> {{ scope.row.contactPhone }}</span>
        </template>

        <template slot="menu"
                  slot-scope="scope"
                  style="width: 300px;">
          <el-link type="primary"
                   :underline="false"
                   @click="updateStatus(scope.row, 1, '审核通过')"
                   v-if="scope.row.status !=1"
                   style="margin-right: 10px">
            审核通过
          </el-link>

          <el-link type="primary"
                   :underline="false"
                   @click="updateStatus(scope.row, 2, '驳回')"
                   style="margin-right: 10px"
                   v-if="scope.row.status !=1"
                   :disabled="scope.row.status ==2">
            驳回
          </el-link>

          <el-link type="primary"
                   :underline="false"
                   @click="detail(scope.row)"
                   style="margin-right: 10px">
            详情
          </el-link>
        </template>

        <el-pagination @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :page-sizes="[10, 20, 30, 50]"
                       layout="sizes, prev, pager, next"
                       :total="page.total">
        </el-pagination>

      </MyTable>
    </div>

    <rejectDialog ref="reject-dialog"
                  @getList="getList" />
    <detailDialog ref="detailDialog" />

  </div>
</template>

<script>
import MyTable from "@/components/myTable";
import rejectDialog from "./components/rejectDialog.vue";
import detailDialog from "./components/detailDialog.vue";
import { mapGetters } from 'vuex'
import {
  getRelationPage,
} from "@/api/product";
import {
  salesAreaSysAudit,
} from "@/api/externalSalesRule";
import avater from "/public/img/default.png";
export default {
  components: { MyTable, rejectDialog, detailDialog },
  data () {
    return {
      avater: avater,
      formTool: {
      },
      btnType: 'add',
      selectionList: [],
      operation: true,
      selection: false,
      index: true,
      tableData: [],
      tableOption: [
        { label: "商户名称", prop: "shopName" },
        { label: "部门名称", prop: "deptName" },
        { label: "运营人员&联系方式", prop: "contactName", slot: true },
        { label: "商品信息", prop: "image", slot: true, minWidth: '210px' }, // 这里表示自定义列
        { label: "售价", prop: "price", slot: true },
        { label: "推广服务费比例", prop: "salesUserRate", slot: true },
        { label: "审核状态", prop: "status", slot: true, },
      ],
      page: {
        total: 10,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      options: [
        {
          value: '0',
          label: '待审核'
        },
        {
          value: '1',
          label: '已通过'

        },
        {
          value: '2',
          label: '驳回'
        },
      ],
      dialogShow: false
    };
  },
  computed: {},
  watch: {},
  created () {
    this.getRelationPage();
  },
  mounted () { },
  beforeCreate () { },
  beforeMount () { },
  beforeUpdate () { },
  updated () { },
  beforeDestroy () { },
  destroyed () { },
  activated () { },
  computed: {
    ...mapGetters(['permissions']),
  },
  methods: {
    // 查看详情
    detail (row) {
      this.$refs.detailDialog.init(row.id)
    },
    updateStatus (row, status, typeText) {
      if (typeText == '驳回') {
        this.$refs['reject-dialog'].init(row);
      } else {
        let params = {
          id: row.id,
          status: 1 //审核状态0待审核1审核通过2审核驳回 
        }
        this.$confirm(`确定要${typeText}【 ${row.shopName}】吗?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.salesAreaSysAudit(params);
          })
          .catch(() => { });
      }

    },

    salesAreaSysAudit (params) {
      salesAreaSysAudit(params).then((res) => {
        if (res) {
          this.$message.success('提交成功');
          this.getList(1)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    didSelectItem (row) {
      // 选择商品
      this.$refs['goods-setting-dailog'].init(row, 'add')
    },
    // 页码变化
    handleCurrentChange (e) {
      this.page.current = e
    },
    // 条数变化
    handleSizeChange (e) {
      this.page.size = e
      this.page.current = 1
    },

    detailHandle (row, btnType) {
      if (btnType == 'add') {
        this.$refs['goods-dailog'].init(row, btnType)
      } else {
        this.$refs['goods-setting-dailog'].init(row, btnType)
      }
    },
    // 重置查询条件
    reset () {
      this.formTool = {};
      this.getList(1);
    },
    // 搜索
    getList (current) {
      this.getRelationPage(current);
    },
    // 勾选
    handleSelectionChange (val) {
      this.selectionList = val;
    },
    // 平台查询控销商品列表
    getRelationPage (current) {
      if (current) {
        // 搜索条件改变从第一页开始查询
        this.page.current = current;
      }

      const params = {
        ...this.formTool,
        current: this.page.current,
        size: this.page.size
      };
      getRelationPage(params).then((res) => {
        const { records, total } = res;
        if (records && records.length > 0) {
          records.forEach(item => {
            // 格式化比例 保留两位小数
            if (item.salesUserRate){
              item['salesUserRateText'] = (item.salesUserRate * 100).toFixed(2)
            }
          });
          this.tableData = records;
          this.page.total = total;
        }else{
          this.tableData = [];
          this.page.total = 0;
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
@import "@/styles/variables.scss";

.classification {
  padding: 0px;

  .header {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 24px 0px 24px !important;
    border-bottom: 1px solid #f5f5f5;

    .font {
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 600;
      text-align: left;
      color: #262626;
    }

    .el-form-item {
      margin: 0px 0px 0px 8px !important;
    }
  }

  background: white;

  .top {
    display: flex;
    padding: 10px 0 10px 0;

    .item {
      display: flex;
      align-items: center;
      margin-right: 20px;

      .label {
        width: 120px;
      }

      .button {
        margin-right: 20px;

        ::v-deep .el-button {
          color: $subMenuActiveText;
          background-color: $butColor;
          border-color: $butColor;

          &:hover {
            color: $subMenuActiveText;
            background-color: $butColor;
            border-color: $butColor;
          }

          &:active {
            color: $subMenuActiveText;
            background: $butColor;
            background-color: $butColor;
            border-color: $butColor;
          }

          &:focus {
            color: $subMenuActiveText;
            background-color: $butColor;
            border-color: $butColor;
          }
        }
      }
    }
  }

  .center {
    margin-top: 16px;
    padding: 0 24px;
    height: calc(100% - 131px);

    .shangjia {
      position: absolute;
      z-index: 2;
      bottom: -45px;
    }
  }

  .btn-warp {
    display: flex;
    justify-content: space-around;

    .el-link {
      // margin: 5px;
    }
  }
}
</style>
